import { Alert } from "bootstrap";
import React, { useEffect, useState } from "react";

function ManualForm({ manualFile }) {

    const [sub, setSub] = useState('');
    const [pred, setPred] = useState('');
    const [obj, setObj] = useState('');
    const [subType, setSubType] = useState('');
    const [objType, setObjType] = useState('');
    const [pmid, setPmid] = useState('');
    const [record, setRecord] = useState([]);
    const [row, setRow] = useState([]);
    const [hideTable, setHideTable] = useState(true);

    const handleAddRow = () => {
        if (sub && pred && obj && subType && objType && pmid) {
            
            const newRecord = {
                subject: sub, 
                predicate: pred.split(' ').filter(item => item !== '').join('_'),
                object: obj, 
                subject_TYPE: subType, 
                object_TYPE: objType, 
                PubMedID: pmid
            };
            console.log(newRecord)
            setRecord([...record, newRecord]);    
            setRow([...row, [sub, pred.split(' ').filter(item => item !== '').join('_'), obj, pmid]])
            setHideTable(false);

            setSub("");
            setPred("");
            setObj("");
            setSubType("");
            setObjType("");
            setPmid("");
        }
        else {
            alert('Please fill all the fileds before adding it.');
        }
    };

    const handleSubmit = () => {
        if (row.length !== 0) manualFile(record);
        else alert('Please enter at least one record.');
    };

    const handleClear = () => {
        setRecord([]);
        setRow([]);
        setHideTable(true);
    }

    const handleDelete = (event) => {
        const del_id = event.target.innerText;
        console.log(del_id);
        const filtered_record = record.filter((r) => r.PubMedID !== del_id);
        const filtered_row = row.filter((r) => r[3] !== del_id);
        console.log(filtered_record);
        console.log(filtered_row);
        setRecord(filtered_record);
        setRow(filtered_row);
    }

    return (
        <div>
            <div className="modal fade" id="formModal" tabIndex="-1">
                <div className="modal-dialog modal-dialog-scrollable modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Relation form</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="subject"
                                        value={sub}
                                        onChange={(e) => setSub(e.target.value)}
                                    />
                                    <label for="source">Subject <span className="required">*</span></label>
                                </div>

                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="predicate"
                                        value={pred}
                                        onChange={(e) => setPred(e.target.value)}
                                    />
                                    <label for="target">Predicate <span className="required">*</span></label>
                                </div>

                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="object"
                                        value={obj}
                                        onChange={(e) => setObj(e.target.value)}
                                    />
                                    <label for="rel">Object <span className="required">*</span></label>
                                </div>

                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="subjectType"
                                        value={subType}
                                        onChange={(e) => setSubType(e.target.value)}
                                    />
                                    <label for="rel">Subject Type <span className="required">*</span></label>
                                </div>

                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="objectType"
                                        value={objType}
                                        onChange={(e) => setObjType(e.target.value)}
                                    />
                                    <label for="rel">Object Type <span className="required">*</span></label>
                                </div>

                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="pmid"
                                        value={pmid}
                                        onChange={(e) => setPmid(e.target.value)}
                                    />
                                    <label for="rel">PubMed ID <span className="required">*</span></label>
                                </div>
                                {row.length !== 0 ?
                                <table className="table table-striped table-bordered center-text align-middle">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Subject</th>
                                            <th scope="col">Predicate</th>
                                            <th scope="col">Object</th>
                                            <th scope="col">Pub Med ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {row.map((record, index) => (
                                            <tr>
                                                <th scope="row">{index+1}</th>
                                                {record.map((data, index) => {
                                                    if (index === 3) {
                                                        return (
                                                            <td key={index}>
                                                                <button type="button" className="row-delete-btn" onClick={handleDelete}>
                                                                    <u>{data}</u>
                                                                </button>
                                                            </td>
                                                        );
                                                    }
                                                    else {
                                                        return (<td key={index}>{data}</td>);
                                                    }
                                                })} 
                                            </tr>
                                        ))} 
                                    </tbody>
                                </table>
                                : <></>}

                                <div 
                                    className="modal-footer" 
                                    >
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        data-bs-dismiss={row.length === 0 ? "" : "modal"}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={handleAddRow}
                                    >
                                        Add Row
                                    </button>

                                    <button
                                        style={{width: "max-content"}}
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={handleClear}
                                    >
                                        Clear Records
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
);}

export default ManualForm;